import { Button } from "@/components/ui/button";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { PublicFeedback } from "./public-feedback";

type FeedbackCardProps = {
	/** Optional card title */
	title?: string;
	/** Optional card description */
	description?: string;
	className?: string;
};

export function FeedbackCard({
	title = "Feedback",
	description = "Solo project—your note goes straight to me. If you include an email, I will only use it to follow up; no marketing lists.",
	className,
}: FeedbackCardProps = {}) {
	return (
		<Card
			className={cn(
				"group relative overflow-hidden border border-border/50 bg-card/50 shadow-lg backdrop-blur-sm transition-all duration-300 hover:shadow-xl",
				className,
			)}
		>
			<CardHeader>
				<CardTitle>{title}</CardTitle>
				<CardDescription>{description}</CardDescription>
			</CardHeader>
			<CardContent>
				<PublicFeedback
					trigger={<Button variant="outline">Submit feedback</Button>}
					title="Send a note"
					description="Bugs, ideas, or rants welcome—I read what lands here."
					path={
						typeof window !== "undefined"
							? window.location.pathname + window.location.search
							: undefined
					}
				/>
			</CardContent>
		</Card>
	);
}
